import "../../../App.css";
import React from "react";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import { ScholarshipsRecesses } from "./ScholarshipsRecesses";
import Footer from "components/layout/Footer";
import { ScholarshipsRecessesNavHeader } from "./ScholarshipsRecessesNavHeader";
import Transition from "components/layout/transition/Transition";
import { useQueryGetAllScholarshipsRecesses } from "../../../hooks/DataFetching/HR/ScholarshipRecesses/useQueryGetAllScholarshipsRecesses";

export function CallScholarshipsRecesses() {
  const { isFetching, isSuccess, data } = useQueryGetAllScholarshipsRecesses();

  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <Transition loading={isFetching} newDesign>
        <ScholarshipsRecessesNavHeader />
        <ScholarshipsRecesses
          scholarshipRecesses={data}
          isSuccess={isSuccess}
        />
        <Footer />
      </Transition>
    </div>
  );
}
